import * as yup from 'yup';

import { formatCountry } from '@blockpulse3/helpers';
import {
  requiredDateField,
  requiredNumberField,
  requiredSelectField,
  requiredStringField,
} from '@blockpulse3/web-client/forms';

import { CompanyInformationsForm } from './types';

export const companyInformationsFormSchema = yup.object({
  name: requiredStringField,
  country: requiredSelectField,
  registrationNumber: requiredStringField,
  registrationEntity: requiredStringField,
  corporateForm: requiredStringField,
  creationDate: requiredDateField,
  shareCapital: requiredNumberField,
  capitalType: yup.object({
    label: yup.string(),
    value: yup.string(),
  }),
  nominalValue: yup.lazy((value) => (value === '' ? yup.string() : yup.number())),
  address: yup.object({
    line: requiredStringField,
    city: requiredStringField,
    postalCode: requiredStringField,
    country: requiredSelectField,
  }),
}) as yup.ObjectSchema<CompanyInformationsForm>;

export const companyInformationsFormDefaults: CompanyInformationsForm = {
  profilePicture: '',
  name: '',
  country: { label: formatCountry('FRA'), value: 'FRA' },
  registrationNumber: '',
  registrationEntity: '',
  corporateForm: '',
  creationDate: '',
  shareCapital: 0,
  address: {
    line: '',
    city: '',
    postalCode: '',
    country: { label: formatCountry('FRA'), value: 'FRA' },
  },
};
